import { jsx as e } from "react/jsx-runtime";
import t from "../base-button.mjs";
import { NeutralTypeEnum as d } from "./enum/neutral-type-enum.mjs";
import { getHoverBorderColor as a, getHoverColor as l } from "./utils/get-colors.mjs";
const b = ({
  neutralType: o = d.blue,
  ...r
}) => /* @__PURE__ */ e(
  t,
  {
    color: "text-text-primary",
    hoverColor: l(o),
    backgroundColor: "bg-background-secondary",
    hoverBackgroundColor: "hover:bg-background-secondary",
    borderColor: "border-text-secondary/30",
    hoverBorderColor: a(o),
    ...r
  }
);
export {
  b as NeutralButton
};
